export default {
    entityKey: 'applications',
    titles: {
        singular: 'Application',
        plural: 'Applications'
    }
}
